import { Component, Input } from '@angular/core';
import { IconoirFloppyDisk, IconoirTrash } from '@ey-xd/motif-icon';
import { MotifIconModule } from '@ey-xd/ng-motif';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-user-action',
  imports: [MotifIconModule, TranslatePipe, TranslateDirective],
  templateUrl: './user-action.component.html',
  styleUrl: './user-action.component.scss',
})
export class UserActionComponent implements ICellRendererAngularComp {
  params: any;
  iconoirTrash = IconoirTrash;
  iconoirFloppyDisk = IconoirFloppyDisk;

  @Input() selectedRole: any;
  @Input() selectedProject: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: any) {
    this.params = params;
    return true;
  }

  get saveDisabled(): boolean {
    return this.params?.isSaveDisabled?.(this.params) ?? false;
  }

  deleteIconHandler() {
    this.params.deleteUserHandler(this.params);
  }

  saveIconHandler() {
    this.params.saveIconHandler(this.params);
  }
}
